import Vue from 'vue';
import { API_HOST } from '../constants';

export default {
  get(position) {
    return Vue.axios.get(`${API_HOST}/ad`, { params: { position } });
  },
  put(id) {
    return Vue.axios.put(`${API_HOST}/ad/${id}`);
  },


};



// WEBPACK FOOTER //
// ./src/api/ad.js